import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../hooks/useSEO.js";
import seoConfig from "../hooks/seoConfig.js";

export default function Science() {
  useSEO(seoConfig.science);

  return (
    <section className="contacts science">
      <Breadcrumbs />

      <h1 className="contacts__title history__title">
        Научная деятельность УрНИИДВиИ
      </h1>

      <div className="footer__middle_block">
        <Link to="/science/research" className="footer__link">
          Научно-исследовательские разработки
        </Link>
        <Link to="/science/development" className="footer__link">
          Разработка медицинских и организационных технологий
        </Link>
        <Link to="/science/dissertation" className="footer__link">
          Диссертационный совет
        </Link>
        <Link to="/science/clinical-trials" className="footer__link">
          Клинические испытания лекарственных средств
        </Link>
        <Link to="/science/publications" className="footer__link">
          Научные публикации
        </Link>
        <Link to="/science/scientific-research" className="footer__link">
          Научные исследования
        </Link>
        <Link to="/science/certification" className="footer__link">
          Аттестация научных работников
        </Link>
        {/* <Link to="/science/assistance" className="footer__link">
              Лечебно-диагностическая помощь
            </Link> */}
      </div>
    </section>
  );
}
